export const ptBR = {
  // Navigation
  nav: {
    title: 'Links Papello',
    orders: 'Pedidos',
    history: 'Histórico',
    conciliation: 'Conciliação',
  },

  // Order Lookup Page
  orderLookup: {
    title: 'Buscar Pedido',
    subtitle: 'Digite o ID do pedido da Tiendanube para começar',
    searchLabel: 'ID do Pedido Tiendanube',
    searchPlaceholder: 'Digite o ID do pedido',
    searchButton: 'Buscar Pedido',
    searching: 'Buscando pedido...',
    orderDetails: 'Detalhes do Pedido',
    orderId: 'ID do Pedido',
    orderNumber: 'Número do Pedido',
    customer: 'Cliente',
    total: 'Total',
    currency: 'Moeda',
    createdAt: 'Criado em',
    products: 'Produtos',
    quantity: 'Quantidade',
    price: 'Preço',
    createPaymentPlan: 'Criar Plano de Pagamento',
    viewExistingPlan: 'Ver Plano Existente',
    existingPlanMessage: 'Este pedido já possui um plano de pagamento.',
  },

  // Payment Builder Page
  paymentBuilder: {
    title: 'Criar Plano de Pagamento',
    subtitle: 'Configure as parcelas de pagamento para este pedido',
    orderInfo: 'Informações do Pedido',
    orderId: 'ID do Pedido',
    customer: 'Cliente',
    total: 'Total',
    paymentParts: 'Parcelas de Pagamento',
    addPart: 'Adicionar Parcela',
    part: 'Parcela',
    amount: 'Valor',
    method: 'Método',
    installments: 'Parcelas',
    description: 'Descrição',
    remove: 'Remover',
    pix: 'PIX',
    creditCard: 'Cartão de Crédito',
    boleto: 'Boleto',
    summary: 'Resumo',
    totalParts: 'Total de Parcelas',
    totalAmount: 'Valor Total',
    remaining: 'Restante',
    createPlan: 'Criar Plano de Pagamento',
    creating: 'Criando plano...',
    validation: {
      minOnePart: 'Adicione pelo menos uma parcela de pagamento',
      totalMismatch: 'O total das parcelas deve ser igual ao total do pedido',
      invalidAmount: 'Valor inválido',
      invalidInstallments: 'Número de parcelas inválido',
    },
  },

  // Payment Status Page
  paymentStatus: {
    title: 'Status do Pagamento',
    subtitle: 'Acompanhe o progresso do pagamento deste pedido',
    planDetails: 'Detalhes do Plano',
    planId: 'ID do Plano',
    orderId: 'ID do Pedido',
    orderNumber: 'Número do Pedido',
    customer: 'Cliente',
    totalAmount: 'Valor Total',
    status: 'Status',
    createdAt: 'Criado em',
    paidAt: 'Pago em',
    paymentParts: 'Parcelas de Pagamento',
    part: 'Parcela',
    amount: 'Valor',
    method: 'Método',
    installments: 'Parcelas',
    paymentStatus: 'Status',
    paymentLink: 'Link de Pagamento',
    copyLink: 'Copiar Link',
    linkCopied: 'Link copiado!',
    openLink: 'Abrir Link',
    progress: 'Progresso',
    paid: 'Pago',
    of: 'de',
    loading: 'Carregando...',
    statuses: {
      pending: 'Pendente',
      paid: 'Pago',
      partial: 'Parcial',
      failed: 'Falhou',
      active: 'Ativo',
    },
  },

  // Payment History Page
  paymentHistory: {
    title: 'Histórico de Planos de Pagamento',
    subtitle: 'Visualize e gerencie todos os planos de pagamento criados anteriormente',
    filters: {
      all: 'Todos os Planos',
      pending: 'Pendentes',
      partial: 'Parciais',
      paid: 'Pagos',
    },
    table: {
      order: 'Pedido',
      customer: 'Cliente',
      totalAmount: 'Valor Total',
      parts: 'Parcelas',
      status: 'Status',
      created: 'Criado',
      actions: 'Ações',
      viewDetails: 'Ver Detalhes',
      store: 'Loja',
      paidParts: 'pagas',
    },
    empty: {
      title: 'Nenhum plano de pagamento encontrado',
      subtitle: 'Comece criando um novo plano de pagamento para um pedido.',
      subtitleFiltered: 'planos de pagamento encontrados.',
      searchOrder: 'Buscar Pedido',
    },
    loading: 'Carregando planos de pagamento...',
  },

  // Conciliation Page
  conciliation: {
    title: 'Conciliação de Pagamentos',
    subtitle: 'Visualize e exporte dados de conciliação para pedidos',
    searchLabel: 'ID do Pedido Tiendanube',
    searchPlaceholder: 'Digite o ID do pedido',
    searchButton: 'Buscar Conciliação',
    searching: 'Buscando dados...',
    orderConciliation: 'Conciliação do Pedido',
    orderId: 'ID do Pedido',
    orderNumber: 'Número do Pedido',
    totalAmount: 'Valor Total',
    paidAmount: 'Valor Pago',
    status: 'Status',
    transactions: 'Transações',
    transaction: 'Transação',
    ipagId: 'ID iPag',
    method: 'Método',
    amount: 'Valor',
    paymentStatus: 'Status',
    createdAt: 'Criado em',
    paidAt: 'Pago em',
    description: 'Descrição',
    exportCSV: 'Exportar CSV',
    exportJSON: 'Exportar JSON',
    noData: 'Nenhum dado de conciliação disponível para este pedido.',
  },

  // Common
  common: {
    error: 'Erro',
    success: 'Sucesso',
    loading: 'Carregando...',
    cancel: 'Cancelar',
    save: 'Salvar',
    delete: 'Excluir',
    edit: 'Editar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    refresh: 'Atualizar',
    close: 'Fechar',
  },

  // Payment Methods
  paymentMethods: {
    pix: 'PIX',
    creditCard: 'Cartão de Crédito',
    boleto: 'Boleto',
  },

  // Statuses
  statuses: {
    pending: 'Pendente',
    paid: 'Pago',
    partial: 'Parcialmente Pago',
    failed: 'Falhou',
    active: 'Ativo',
    inactive: 'Inativo',
  },
};

export default ptBR;
